import * as React from 'react';
import { Container, Responsive } from 'vendors/semantic-ui';

import { configUI } from 'config';
import { CtaImage } from 'modules/shared-ui/components';
import { readCMSValue } from 'modules/shared-cms/utils';
import { MentionContainer, TitleBlocContainer } from 'modules/shared-cms-advanced/components';

import { getBrandCDNUrl } from 'modules/shared/utils';
import { CatalogueAdvantage } from '../../components/shared';
import { productService } from '../../services';
import { EnhancedQuerystringFilterableProductList } from '../../enhanced-components';
import { BrandDetails, SignImage } from '../../components';

import { BrandProps } from './brand-type';
import enhancer from './brand-enhancer';

import styles from './brand-page.module.css';

const brandPage: React.FC<BrandProps> = React.memo(
    ({ id, brand, cmsBrandData, cmsBrandCorner, ...rest }: BrandProps) => {
        const signData = rest && rest.cmsSignData && rest.cmsSignData.length > 0 ? rest.cmsSignData[0].data : undefined;

        const cmsBrandCornerData =
            cmsBrandCorner && cmsBrandCorner.length > 0 ? readCMSValue(cmsBrandCorner[0].data) : undefined;

        const brandLogo = (cmsBrandCornerData ? readCMSValue(cmsBrandCornerData.picture) : undefined) || [];
        if (brandLogo.length === 0 && brand.monogram) {
            brandLogo.push({
                url: getBrandCDNUrl(brand.monogram) || '',
                fileSize: -1, // Not used
            });
        }
        const brandLink = (cmsBrandCornerData ? readCMSValue(cmsBrandCornerData.link) : undefined) || brand.link || '';
        const brandMention = (cmsBrandCornerData ? readCMSValue(cmsBrandCornerData.mention) : undefined) || '';

        return (
            <React.Fragment>
                {cmsBrandCorner &&
                cmsBrandCorner.length > 0 &&
                (readCMSValue(cmsBrandCorner[0].data.titleBlocPicture) ||
                    readCMSValue(cmsBrandCorner[0].data.titleBlocTitle)) ? (
                    <TitleBlocContainer {...cmsBrandCorner[0].data} />
                ) : (
                    <React.Fragment>{brand && <BrandDetails {...brand} />}</React.Fragment>
                )}
                <MentionContainer mention={brandMention} mentionFontSize={10} mentionTextColor="#000000" />
                <Container>
                    <div className={styles.container}>
                        <CatalogueAdvantage
                            signId={brand ? brand.signId : ''}
                            cmsBrandData={cmsBrandData}
                            cmsBrandCorner={cmsBrandCorner}
                            {...rest}
                            containerClassName={styles.innerAdvantageContainer}
                            secondaryTitle={
                                signData ? (
                                    <Responsive minWidth={configUI.responsive.computer.minWidth}>
                                        <SignImage {...signData} name={signData.pageTitle} />
                                    </Responsive>
                                ) : (
                                    undefined
                                )
                            }
                        />
                        {!!signData && (
                            <Responsive maxWidth={configUI.responsive.tablet.maxWidth}>
                                <div className={styles.mobileSignContainer}>
                                    <SignImage {...signData} name={signData.pageTitle} />
                                </div>
                            </Responsive>
                        )}
                        <EnhancedQuerystringFilterableProductList
                            id={id}
                            fetchProducts={productService.searchByBrand}
                        />
                        {brandLogo.length !== 0 && (
                            <div className={styles.logo}>
                                <CtaImage link={brandLink} target="blank" picture={brandLogo} />
                            </div>
                        )}
                    </div>
                </Container>
            </React.Fragment>
        );
    },
);

export const BrandPage = enhancer(brandPage);
